import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaHome, FaUser, FaBox, FaImage, FaStar, FaCog, FaChevronLeft, FaChevronRight
} from 'react-icons/fa';
import { useAuthContext } from '../../../context/AuthContext';

import '../../admin/layout/style/Sidebar.css';
import logo from '../../admin/layout/assets/logo.png';

const ServiceSidebar = ({ isOpen, toggleSidebar, collapsed, onToggleCollapse }) => {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuthContext();

  // Don't show sidebar if not authenticated
  if (!isAuthenticated || loading) {
    return null;
  }

  const handleToggleCollapse = () => {
    onToggleCollapse();
  };

  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      toggleSidebar();
    }
  };

  const menuItems = [
    { to: "/service-provider", icon: FaUser, label: "Profile", exact: true },
    { to: "/service-provider/packages", icon: FaBox, label: "Packages" },
    { to: "/service-provider/picha", icon: FaImage, label: "Picha" },
    { to: "/service-provider/reviews", icon: FaStar, label: "Reviews" },
  ];

  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <>
      <div className={`sidebar-container ${isOpen ? 'open' : ''} ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-glass">
          {/* Sidebar Header */}
          <div className="sidebar-header">
            <div className="logo-wrapper">
              <div className="logo-container">
                <img src={logo} alt="Harusi Online Logo" className="sidebar-logo" />
                {!collapsed && (
                  <div className="logo-text">
                    <h3>Harusi Online</h3>
                    <p>Watoa Huduma</p>
                  </div>
                )}
              </div>
            </div>
            <button
              className="sidebar-toggle"
              onClick={handleToggleCollapse}
              title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
            </button>
          </div>

          {/* Navigation Menu */}
          <nav className="sidebar-nav">
            <ul className="nav-menu">
              {menuItems.map((item, index) => {
                const Icon = item.icon;
                const active = isActive(item.to, item.exact);

                return (
                  <li key={index} className="nav-item-wrapper">
                    <Link
                      to={item.to}
                      className={`nav-item ${active ? 'active' : ''} ${collapsed ? 'collapsed' : ''}`}
                      onClick={handleLinkClick}
                      title={collapsed ? item.label : ''}
                    >
                      <div className="nav-icon-container">
                        <Icon className="nav-icon" />
                        {!collapsed && <span className="nav-label">{item.label}</span>}
                      </div>
                      {active && <div className="active-indicator"></div>}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>

      {/* Mobile Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default ServiceSidebar;
